import React from 'react';

function ComponentDetached({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <rect x="12.5" y="13.8792" width="6.5" height="6.5" rx="1.3" />
      <rect x="15.75" y="2" width="6.5" height="6.5" rx="1.3" transform="rotate(30 15.75 2)" />
      <rect x="3" y="13.8792" width="6.5" height="6.5" rx="1.3" />
      <rect x="3" y="4.28101" width="6.5" height="6.5" rx="1.3" />
    </svg>
  );
}

export default ComponentDetached;
